import React from 'react';
import { Lock, CreditCard } from 'lucide-react';
import { t } from '../services/i18n';

interface ToolLockedProps {
  toolName: string;
  onUpgrade: () => void;
}

export const ToolLocked: React.FC<ToolLockedProps> = ({ toolName, onUpgrade }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4 relative">
      {/* Blurred background effect */}
      <div className="absolute inset-0 backdrop-blur-sm bg-black/50"></div>
      
      {/* Lock overlay */}
      <div className="relative z-10 bg-slate-900/95 border-2 border-slate-700 rounded-2xl p-12 max-w-2xl w-full text-center shadow-2xl">
        <div className="mb-6 flex justify-center">
          <div className="p-6 bg-red-500/20 rounded-full border-2 border-red-500/50">
            <Lock size={64} className="text-red-400" />
          </div>
        </div>
        
        <h2 className="text-3xl font-bold text-white mb-4">
          {toolName} {t('common.locked') || 'Locked'}
        </h2>
        
        <p className="text-slate-300 text-lg mb-2">
          {t('common.getPlanToUse') || 'Get a plan to use this tool'}
        </p>
        
        <p className="text-slate-400 mb-8">
          {t('common.upgradeToAccess') || 'Upgrade to a paid plan to unlock all features and tools'}
        </p>
        
        <button
          onClick={onUpgrade}
          className="px-8 py-4 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-bold text-lg transition-all flex items-center gap-3 mx-auto shadow-lg shadow-indigo-500/50"
        >
          <CreditCard size={24} />
          {t('paywall.title') || 'Choose a Plan'}
        </button>
        
        <div className="mt-8 pt-8 border-t border-slate-700">
          <p className="text-sm text-slate-500">
            {t('common.freeToolsAvailable') || 'Free tools: Site Audit, Keyword Research, Competitor Analysis, AI Tools'}
          </p>
        </div>
      </div>
    </div>
  );
};

